"use client";

import styles from "./index.module.scss";
import { useState } from "react";
import SunIcon from "../icons/sun";
import MoonIcon from "../icons/moon";

export default function DarkModeSwitch() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
    document.documentElement.classList.toggle("dark");
  };

  return (
    <div onClick={toggleTheme} className={styles.switchCont}>
      {isDarkMode ? <SunIcon /> : <MoonIcon />}
    </div>
  );
}
